import { useMemo } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { useEditCanvasStore } from '../../store';
import { useFlattenAction } from '../group/useFlattenAction';
import { useIsGroupSelection } from '../group/useIsGroupSelection';

export const useFlattenShortcut = () => {
  const readOnly = useEditCanvasStore((s) => s.readOnly);
  const isGroupSelection = useIsGroupSelection();
  const { handleFlatten, isFlattening } = useFlattenAction();

  const options = useMemo(
    () => ({
      enabled: isGroupSelection && !readOnly && !isFlattening,
      preventDefault: true,
    }),
    [isGroupSelection, readOnly, isFlattening],
  );

  useHotkeys(
    'alt+shift+f',
    () => {
      void handleFlatten();
    },
    options,
    [handleFlatten, options],
  );
};
